import * as lame from '@breezystack/lamejs'

export async function encodeAudioBufferToMp3(
	audioBuffer: AudioBuffer,
	bitrateKbps: number = 128
): Promise<Blob> {
	const numberOfChannels = audioBuffer.numberOfChannels
	const sampleRate = audioBuffer.sampleRate

	const encoder = new lame.Mp3Encoder(numberOfChannels, sampleRate, bitrateKbps)
	const samplesPerFrame = 1152

	const left = audioBuffer.getChannelData(0)
	const right = numberOfChannels > 1 ? audioBuffer.getChannelData(1) : null

	const mp3Data: Uint8Array[] = []

	const floatTo16Bit = (sample: number): number => {
		const s = Math.max(-1, Math.min(1, sample))
		return s < 0 ? s * 0x8000 : s * 0x7fff
	}

	for (let i = 0; i < left.length; i += samplesPerFrame) {
		const frameSize = Math.min(samplesPerFrame, left.length - i)
		const leftChunk = new Int16Array(frameSize)
		let rightChunk: Int16Array | undefined

		if (right) {
			rightChunk = new Int16Array(frameSize)
		}

		for (let j = 0; j < frameSize; j++) {
			leftChunk[j] = floatTo16Bit(left[i + j])
			if (right && rightChunk) {
				rightChunk[j] = floatTo16Bit(right[i + j])
			}
		}

		let mp3buf: Uint8Array
		if (numberOfChannels === 2 && right && rightChunk) {
			mp3buf = encoder.encodeBuffer(leftChunk, rightChunk)
		} else {
			mp3buf = encoder.encodeBuffer(leftChunk)
		}

		if (mp3buf.length > 0) {
			mp3Data.push(mp3buf)
		}
	}

	const end = encoder.flush()
	if (end.length > 0) {
		mp3Data.push(end)
	}

	return new Blob(mp3Data, { type: 'audio/mpeg' })
}

export async function convertWavBlobToMp3(
	wavBlob: Blob,
	bitrateKbps: number = 128
): Promise<Blob> {
	const arrayBuffer = await wavBlob.arrayBuffer()
	const audioContext = new (window.AudioContext ||
		(window as any).webkitAudioContext)()
	const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
	return encodeAudioBufferToMp3(audioBuffer, bitrateKbps)
}
